import { render, staticRenderFns } from "./HomePosts.vue?vue&type=template&id=20a9a45a&"
import script from "./HomePosts.vue?vue&type=script&lang=js&"
export * from "./HomePosts.vue?vue&type=script&lang=js&"
import style0 from "./HomePosts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports